import {
    amber50,
    amber200,
    amber400,
    amber700,
    grey900,
} from "material-ui/styles/colors";

var GreenTheme = {
    fontFamily: "arial",
    palette : {
        primary1color:      amber700,
        primary2color:      amber400,
        primary3color:      amber200,
        accent1color:       "#E73677",
        accent2color:       "#D0FFCA",
        accent3color:       "#FF9797",
        textColor:          grey900,
        canvasColor:        amber50,
        alternateTextColor: amber200, // Button background color.
    }
};

export default GreenTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/AmberTheme.js
 **/